var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.893a2.982 2.982 0 100-5.964 2.982 2.982 0 000 5.964z",
    fill: "#61DAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.02c8.837 0 16-2.735 16-6.11 0-3.373-7.163-6.108-16-6.108S1 13.537 1 16.91s7.163 6.109 16 6.109z",
    stroke: "#61DAFB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 19.965c4.418 7.653 10.368 12.49 13.29 10.802 2.922-1.687 1.709-9.258-2.71-16.91C17.873 6.203 11.923 1.366 9 3.054c-2.922 1.687-1.709 9.258 2.71 16.91z",
    stroke: "#61DAFB",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 13.856C7.29 21.51 6.077 29.08 9 30.767c2.922 1.687 8.872-3.149 13.29-10.802C26.71 12.313 27.922 4.742 25 3.055c-2.922-1.687-8.872 3.149-13.29 10.801z",
    stroke: "#61DAFB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.f1c26aca6c85f4663051a0ca0d3c4feb.svg";
export { ForwardRef as ReactComponent };